export default __webpack_public_path__ + "static/1-8f6247b8711353974e365504e14ea900.gif";